// TODO: DELETE THIS FILE.
// DO NOT USE THESE COMPONENTS
import {
  Checkbox as AntCheckbox,
  Form as AntForm,
  Input as AntInput,
  InputNumber as AntInputNumber,
} from 'antd';
import styled from 'styled-components';

import LibSelect from 'components/lib2/Select2';

const FormItem = styled(AntForm.Item)`
  align-self: flex-end;
  width: 100%;
`;

const PhoneFormItem = styled(FormItem)`
  flex-basis: 150%;
  margin-right: 2px;
`;

const StyledAntInputNumber = styled(AntInputNumber)`
  margin-right: 2px;
  width: calc(100% - 8px) !important;
  > .ant-input-number-handler-wrap {
    display: none;
  }
`;

/**
 * @deprecated use Input from '@frontend/legacy-components' instead.
 */
const Input = ({ field, form: { touched, errors }, label, ...props }) => {
  const isInvalid = touched[field.name] && errors[field.name];
  return (
    <FormItem
      label={label}
      validateStatus={isInvalid ? 'error' : undefined}
      help={isInvalid && errors[field.name]}
    >
      <AntInput {...field} {...props} />
    </FormItem>
  );
};

/**
 * @deprecated use Input from '@frontend/legacy-components' instead.
 */
const PhoneInput = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  label,
  formItemProps = {},
  ...props
}) => {
  const isInvalid = touched[field.name] && errors[field.name];
  return (
    <PhoneFormItem
      label={label}
      validateStatus={isInvalid ? 'error' : undefined}
      help={isInvalid && errors[field.name]}
      {...formItemProps}
    >
      <StyledAntInputNumber
        {...field}
        {...props}
        formatter={(valueIn) => {
          const value = String(valueIn).replace(/\D/g, '');
          const result =
            value.length < 4
              ? value
              : value.length < 7
              ? `(${value.substr(0, 3)}) ${value.substr(3, value.length - 3)}`
              : value.length < 10
              ? `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(
                  6,
                  value.length - 6,
                )}`
              : `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(
                  6,
                  4,
                )}`;
          return result;
        }}
        parser={(valueIn) => {
          const value = String(valueIn).replace(/\D/g, '');
          const length = value.length <= 10 ? value.length : 10;
          return value.slice(0, length);
        }}
        onChange={(value) => {
          setFieldValue(field.name, value);
          setFieldTouched(field.name, true);
        }}
      />
    </PhoneFormItem>
  );
};

const StyledLibSelect = styled(LibSelect)`
  line-height: 1.4;

  .react-select__control {
    min-height: 32px;
    height: 32px;
    background-color: white;
  }

  .react-select__control--is-focused {
    border-color: #49a9ee !important;
    box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
  }

  .react-select__single-value {
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
  }

  .react-select__indicators {
    top: 1em;
  }
`;

/**
 * @deprecated use Select from '@frontend/legacy-components' instead.
 */
const Select = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  label,
  filterOption,
  ...props
}) => {
  const isInvalid = touched[field.name] && errors[field.name];
  return (
    <FormItem
      label={label}
      validateStatus={isInvalid ? 'error' : undefined}
      help={isInvalid && errors[field.name]}
    >
      <StyledLibSelect
        {...field}
        {...props}
        filterOption={
          filterOption ||
          ((option, inputValue) =>
            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) === 0)
        }
        onChange={
          props.onChange
            ? props.onChange
            : (value) => {
                setFieldValue(field.name, value);
                setFieldTouched(field.name, true);
              }
        }
        onBlur={() => setFieldTouched(field.name, true)}
      />
    </FormItem>
  );
};

/**
 * @deprecated use Checkbox from '@frontend/legacy-components' instead.
 */
const Checkbox = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  label,
  onChange,
  ...props
}) => {
  const isInvalid = touched[field.name] && errors[field.name];
  const handleChange = onChange
    ? onChange
    : (e) => {
        setFieldValue(field.name, e.target.checked);
        setFieldTouched(field.name, true);
      };
  return (
    <FormItem
      validateStatus={isInvalid ? 'error' : undefined}
      help={isInvalid && errors[field.name]}
    >
      <AntCheckbox
        {...field}
        {...props}
        checked={field.value}
        onChange={handleChange}
        onBlur={() => setFieldTouched(field.name, true)}
      >
        {label}
      </AntCheckbox>
    </FormItem>
  );
};

export { Checkbox, Input, PhoneInput, Select };
